<template>
  <v-menu v-if="username">
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        :max-width="isExtraSmall ? undefined : '50%'"
        variant="text"
        :style="isExtraSmall ? undefined : 'display: block; text-align: left'"
        :icon="isExtraSmall"
        data-test-id="user-menu-trigger"
      >
        <v-icon v-if="isExtraSmall" color="primary" size="x-large">mdi-account-circle</v-icon>
        <template v-else>
          <span
            class="text-truncate text-none font-weight-regular"
            data-test-id="user-menu-username"
            >{{ username }}</span
          ><v-icon>mdi-menu-down</v-icon>
        </template>
      </v-btn>
    </template>
    <v-list>
      <!-- User info header like GitLab -->
      <v-list-item class="user-info-header">
        <template #prepend>
          <v-icon style="opacity: 0; visibility: hidden;">mdi-account-circle</v-icon>
        </template>
        <v-list-item-title class="font-weight-medium">{{ username }}</v-list-item-title>
      </v-list-item>
      
      <v-divider class="my-2"></v-divider>
      
      <!-- Menu actions -->
      <v-list-item
        data-test-id="user-menu-logout-trigger"
        @click="$emit('LOGOUT_REQUEST')"
      >
        <template #prepend>
          <v-icon>mdi-logout</v-icon>
        </template>
        <v-list-item-title>{{
          $t('user_avatar__logout', 'Log out')
        }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
/**
 * A drop-down menu presenting the available user actions
 */
import { computed } from 'vue';
import { useDisplay } from 'vuetify';

const _props = defineProps<{ username?: string | null }>();

const display = useDisplay();

// Show only icon on extra small screens (mobile)
const isExtraSmall = computed(() => display.xs.value);
</script>

<style scoped>
.user-info-header {
  padding: 12px 16px !important;
  background-color: rgba(0, 0, 0, 0.02);
  cursor: default;
}

.user-info-header:hover {
  background-color: rgba(0, 0, 0, 0.02) !important;
}
</style>
